import uuid from 'uuid/v1'
import { useBoxes } from '../Contexts/BoxContext'

// handles selecting an item type to add (New Item menu, quick add tiles)
export default function useAddBoxSelect(onAddBox, currentUnitModel) {
    const { addUnitBox, unitBoxes } = useBoxes()

    return itemType => {
        const savedBox = {
            unitUid: currentUnitModel?.uId,
            channels: currentUnitModel?.channels,
        }

        const savedData = {
            ...savedBox,
            type: 'eventLogger',
            id: uuid(),
            timeType: 'local',
            timeFormat: 'dateTime',
            itemPosition: {
                rowIndex: unitBoxes.length,
                position: 'Stretch',
            },
        }
        onAddBox(itemType)
        if (itemType === 'map') {
            addUnitBox('m')
        }
        if (currentUnitModel && itemType === 'eventLogger') {
            onAddBox(savedData)
            addUnitBox(savedData)
        }
    }
}
